import { render } from "./ReferenceCardPages.vue?vue&type=template&id=4ade2700&scoped=true"
import script from "./ReferenceCardPages.vue?vue&type=script&lang=js"
export * from "./ReferenceCardPages.vue?vue&type=script&lang=js"

import "./ReferenceCardPages.vue?vue&type=style&index=0&id=4ade2700&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ade2700"]])

export default __exports__